/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { ExportToolRequest } from '../types/ExportTool';
import type { ExportToolResponse } from '../types/ExportTool';

export type ExportToolsUpdateRequest = ExportToolRequest;
export type ExportToolsUpdateResponse = ExportToolResponse;

export type ExportToolsUpdateQuery = {
  /**
   * ```yaml
   * in: path
   * name: id
   * schema:
   *   type: integer
   * description: A unique integer value identifying this export tool.
   * required: true
   * ```
   */
  id?: number;
};

/**
 * PUT /dmx-server/export_tools/{id}/
 *
 * ```yaml
 * operationId: export_tools_update
 * tags:
 *   - export_tools
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/ExportTool'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/ExportTool'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/ExportTool'
 *   required: true
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/ExportTool'
 *     description: ''
 * ```
 */
export const exportToolsUpdateOperation = ({ id, ...rest }: ExportToolsUpdateQuery) =>
  ({
    method: 'PUT',
    path: `/dmx-server/export_tools/${id}/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'PUT';
    path: string & { _templateUrl: '/dmx-server/export_tools/{id}/' };
  };

/**
 * PUT /dmx-server/export_tools/{id}/
 *
 * ```yaml
 * operationId: export_tools_update
 * tags:
 *   - export_tools
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/ExportTool'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/ExportTool'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/ExportTool'
 *   required: true
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/ExportTool'
 *     description: ''
 * ```
 */
export const exportToolsUpdate = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query: ExportToolsUpdateQuery;
  request: ExportToolRequest;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<ExportToolResponse>> => {
  const operation = exportToolsUpdateOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'PUT',
    request,
    onUploadProgress,
    cancelToken,
  );
};
